import plutioProvider from "../../providers/prod/plutio";
import {
	AddOn,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
	SettingsConfig,
	SettingsConfigType,
} from "../../../../index";

const a012AddOn = new AddOn({
	internalId: "a012",
	externalId: "pro_01kysgn1r57mejv8yfkxs4f3qh",
	shortName: "Plutio AI Collaborators",
	longName: "Plutio AI Collaborators",
	shortDescription: "Assign Plutio tasks to AI collaborators that deliver GitHub pull requests",
	longDescription:
		"Create AI collaborators with their own invite email, model, instructions, projects, and repositories. Plutio webhooks turn assignments and notes into isolated GitHub branches and pull requests, with status and controls embedded in Plutio.",
	type: AddOnType.SERVICE,
	iconAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a012/icons/a012_icon_rounded.png"
	),
	coverAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/background1.png"
	),
	previewAssets: [],
	docsUrl: "",
	providersIds: [plutioProvider._.id],
	status: AddOnStatus.ACTIVE,
	plans: [
		new AddOnPlan({
			billingCycle: BillingCycle.yearly(),
			internalId: "a012_p001",
			externalId: "pri_01kysgq18ydztt4agvmv3bezwd",
			prices: [new Price({ currency: Currency.USD, amount: 28 })],
		}),
		new AddOnPlan({
			billingCycle: BillingCycle.monthly(),
			internalId: "a012_p002",
			externalId: "pri_01kysgr5b8rgp2y82w70xybmkm",
			prices: [new Price({ currency: Currency.USD, amount: 4 })],
		}),
	],
	settingsConfig: [
		new SettingsConfig({
			id: "plutio_workspace",
			label: "Plutio workspace",
			description: "Select the Plutio workspace where AI collaborators receive tasks.",
			type: SettingsConfigType.INTEGRATION,
			validators: "plutio",
			required: true,
		}),
		new SettingsConfig({
			id: "github_integration",
			label: "GitHub integration",
			description: "Select the GitHub integration used for issue and pull request sync.",
			type: SettingsConfigType.INTEGRATION,
			validators: "github",
			required: true,
		}),
		new SettingsConfig({
			id: "comment_sync_enabled",
			label: "Comment sync",
			description: "Sync comments between linked Plutio tasks and GitHub issues by default.",
			type: SettingsConfigType.BOOLEAN,
			default_value: true,
		}),
	],
	highlightFeatures: [
		new HighlightFeature({
			title: "Assign work like a teammate",
			description:
				"Invite each AI collaborator by email, assign tasks in Plutio, and continue work through task notes.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/repeat.svg",
		}),
		new HighlightFeature({
			title: "Pull requests from Plutio",
			description:
				"Each run works on an isolated GitHub branch and opens a pull request for human review.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/eye.svg",
		}),
		new HighlightFeature({
			title: "Your models and keys",
			description:
				"Choose a model per collaborator, keep BYOK credentials encrypted, and monitor every run.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/shield-check.svg",
		}),
	],
});

export default a012AddOn;
